"use strict";

class PropertyAssetsController {

    constructor(SSHttpService, SSUtilService, SSAlertService, OTPService, SSConfigService, SSAwsService, SSUserService) {
        const self = this;

        self.SSHttpService = SSHttpService;
        self.SSUtilService = SSUtilService;
        self.SSAlertService = SSAlertService;
        self.OTPService = OTPService;
        self.SSConfigService = SSConfigService;
        self.SSAwsService = SSAwsService;
        self.SSUserService = SSUserService;

        self.data = SHOWSUITE.data;

        self.propertyAssetTypes = {
            "Project Logo Image": SHOWSUITE.assetLogoImgConst,
            "Hero Image": SHOWSUITE.assetHeroImgConst,
            "Key Images": SHOWSUITE.assetKeyImgConst,
            "Facility Images": SHOWSUITE.assetFacilityImgConst,
            "360 Images"        : SHOWSUITE.asset360ImgConst,
            "General Lifestyle Images": SHOWSUITE.assetLifeStyleImgConst,
            "Site Plan 1 Images": SHOWSUITE.assetSitePlanAImgConst,
            "Site Plan 2 Images": SHOWSUITE.assetSitePlanBImgConst,
            "Brochure (PDF)": SHOWSUITE.assetBrochurePdfConst,
            "Floor Plan (PDF)": SHOWSUITE.assetFloorPlanPdfConst,
            "Floor Plan (Image 1)": SHOWSUITE.assetFloorPlan1ImgConst,
            "Map Images": SHOWSUITE.assetMapImgConst,
            "Project Developer Logo": SHOWSUITE.PROPERTY_ASSET_TYPE_DEVELOPER_LOGO,
            "Project Architect Logo": SHOWSUITE.assetProjectArchitectLogoConst,
            "Project Builder Logo": SHOWSUITE.assetProjectBuilderLogoConst,
            "Project Managed By Logo": SHOWSUITE.assetProjectManagedByLogoConst,
            "Annexes Downloads (PDF)": SHOWSUITE.assetAnnexesDownloads,
            "Airview Images": SHOWSUITE.assetAirViewImgConst,
            "Airview 3D": SHOWSUITE.assetAirView3DConst,
            "Show Gallery 360": SHOWSUITE.PROPERTY_ASSET_TYPE_SHOW_GALLERY_360,
            "Architectural 360": SHOWSUITE.PROPERTY_ASSET_TYPE_ARCHITECTURAL_360
        };
        self.propertyVideoTypes = {
            "Ad Videos": SHOWSUITE.assetAdVideoConst,
            "Layout Videos": SHOWSUITE.assetLayoutVideoConst,
        };

        self.propertyShareAssetTypes = {
            "Hero Image": SHOWSUITE.PROPERTY_ASSET_TYPE_SHARE_HERO_IMAGE,
            "Floor Plan": SHOWSUITE.PROPERTY_ASSET_TYPE_SHARE_FlOOR_PLAN,
            "Ad Videos": SHOWSUITE.PROPERTY_ASSET_TYPE_SHARE_AD_VIDEO,
            "360 Images": SHOWSUITE.PROPERTY_ASSET_TYPE_SHARE_360_IMAGE,
            "3D Interactive Model": SHOWSUITE.PROPERTY_ASSET_TYPE_SHARE_INTERACTIVE_MODEL_3D,
            "Airview Images": SHOWSUITE.PROPERTY_ASSET_TYPE_SHARE_AIR_VIEW,
            "Airview 3D": SHOWSUITE.PROPERTY_ASSET_TYPE_SHARE_AIR_VIEW_3D,
            "Storey View": SHOWSUITE.PROPERTY_ASSET_TYPE_SHARE_STOREY_VIEW,
            "Show Gallery 360": SHOWSUITE.PROPERTY_ASSET_TYPE_SHARE_SHOW_GALLERY_360,
            "Architectural 360": SHOWSUITE.PROPERTY_ASSET_TYPE_SHARE_ARCHITECTURAL_360
        };

        self.propertyVideoParams = {};
        self.propertyVideoParams[SHOWSUITE.assetAdVideoConst] = null;
        self.propertyVideoParams[SHOWSUITE.assetLayoutVideoConst] = null;

        self.TYPE_360_IMAGE = SHOWSUITE.asset360ImgConst;
        self.TYPE_AIR_VIEW_IMAGE = SHOWSUITE.assetAirViewImgConst;
        self.TYPE_AIR_VIEW_3D = SHOWSUITE.assetAirView3DConst;
        self.TYPE_SHOW_GALLERY_360 = SHOWSUITE.PROPERTY_ASSET_TYPE_SHOW_GALLERY_360;
        self.TYPE_ARCHITECTURAL_360 = SHOWSUITE.PROPERTY_ASSET_TYPE_ARCHITECTURAL_360;
        self.assetType360Image = null;
        self.assetTypeAirViewImage = null;
        self.assetTypeAirView3D = null;
        self.assetTypeShowGallery360 = null;
        self.assetTypeArchitectural360 = null;

        self.hrefAssets = [SHOWSUITE.assetAdVideoConst, SHOWSUITE.assetLayoutVideoConst, SHOWSUITE.assetBrochurePdfConst, SHOWSUITE.assetFloorPlanPdfConst, SHOWSUITE.assetAnnexesDownloads];

        self.has_access = false;
        if (self.SSUserService.isDeveloper()) {
            self.init();
            self.has_access = true;
        }
    }

    init() {
        const self = this;
        self.getProperty();
    }

    // Property --------------------------------------------------------------------------------------------------------
    getProperty() {
        const self = this;

        if (!self.data.property_id)
            return;

        self.property = null;
        self.propertyParams = null;

        let url = 'sec/developer/properties/' + self.data.property_id;

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.property = response.data.property;
            self.propertyParams = angular.copy(self.property);
            self.filterPropertyAssets();
        });
    }
    // Property --------------------------------------------------------------------------------------------------------

    // Assets ----------------------------------------------------------------------------------------------------------
    filterPropertyAssets() {
        const self = this;

        self.assetFiles = {};

        if (self.property.property_assets) {
            _.forEach(self.property.property_assets, function (asset) {
                if (!_.has(self.assetFiles, asset.type))
                    self.assetFiles[asset.type] = [];

                self.assetFiles[asset.type].push(asset);
            });
        }
    }

    removeAsset(asset, type, idx) {
        const self = this;

        self.OTPService.getVerified(
            self.OTPService.TYPE_SESSION_2FA,
            function (data) {

                let url = 'sec/developer/properties/' + self.property.id + '/assets/' + asset.id + '/delete';

                loading(true);
                self.SSHttpService.getAPIRequest(url).then(function (response) {
                    loading(false);

                    if (response instanceof Error) {
                        self.SSAlertService.parseAndDisplayError(response);
                        return;
                    }
                    self.SSAlertService.success('Success!', 'Image removed successfully.');

                    self.assetFiles[type].splice(idx, 1); // remove from files index
                });
            }
        );
    }

    uploadPropertyFiles(files, type, share = false, thumbnail = null) {
        const self = this;

        if (!files || !type)
            return;

        if (share) {
            let share_fail = false;
            $.each(files, function(index, file) {
                if (file.size / 1024 > 300) {
                    share_fail = true;
                }
            });

            if (share_fail) {
                self.SSAlertService.danger("Error!", "Only maximum 300KB image is allowed.");
                return;
            }

        }
        self.thumbnail = null;

        let policyUrl = 'sec/developer/properties/' + self.property.id + '/assets/s3-policy-document';

        loading(true);
        self.SSAwsService.policyAPIRequest(policyUrl, function (policyObj) {
            loading(false);

            if (policyObj instanceof Error) {
                self.SSAlertService.error("Unable to upload file. Please contact support.");
                return;
            }

            jQuery.each(files, function (i, file) {

                loading(true);
                self.SSAwsService.upload(file, policyObj, function (response) {
                    loading(false);

                    if (response instanceof Error) {
                        self.SSAlertService.parseAndDisplayError(response);
                        return;
                    }

                    if(thumbnail){
                        if(!(self.thumbnail && self.thumbnail.hasOwnProperty(type))){
                            self.thumbnail = {};
                        }
                        if(thumbnail.add){
                            self.thumbnail[type] = {
                                "uri": response.config.data.key,
                                "name": response.config.data.file.name,
                                "add": thumbnail.add
                            };
                        }
                        else{
                            self.thumbnail[type] = { "id": thumbnail.id };
                            thumbnail.thumbnail_uri = response.config.data.key;
                        }
                        self.addAsset(type, response.config.data.file.name, thumbnail.file_uri, thumbnail);
                    }
                    else{
                        self.addAsset(type, response.config.data.file.name, response.config.data.key);
                    }
                });
            });
        });
    }

    addAsset(type, name, fileUri, asset = null) {
        const self = this;

        if (!(type && name && fileUri))
            return;

        self.OTPService.getVerified(
            self.OTPService.TYPE_SESSION_2FA,
            function (data) {

                let url = 'sec/developer/properties/' + self.property.id + '/assets/add-asset';
                let params = {
                    "type": type,
                    "name": name,
                    "file_uri": fileUri
                };

                if(asset){
                    params.id = asset.id;
                    params.thumbnail_uri = asset.thumbnail_uri;
                }
                else if(self.thumbnail && self.thumbnail[type]){

                    if(self.thumbnail[type].add){
                        params.thumbnail_uri = self.thumbnail[type].uri;
                        params.name = self.thumbnail[type].name;
                    }

                    if(self.thumbnail[type].id){
                        params.id = self.thumbnail[type].id;
                    }
                }

                let handleResponse = function (response) {
                    loading(false);

                    if (response instanceof Error) {
                        self.SSUtilService.logError("Error in uploading Asset with path " + fileUri);
                        return;
                    }

                    if (!_.has(self.assetFiles, type)) {
                        self.assetFiles[type] = [];
                    }
                    self.assetType360Image = null;
                    self.assetTypeAirViewImage = null;
                    if(!asset){
                        self.assetFiles[type].push(response.data);
                    }
                    if(self.thumbnail){
                        self.thumbnail = null;
                    }
                };

                loading(true);
                self.SSHttpService.postAPIRequest(url, params).then(handleResponse);
            }
        );
    }
    // Assets ----------------------------------------------------------------------------------------------------------

    // 3D Model URL ----------------------------------------------------------------------------------------------------
    editPropertyModel3d(status) {
        const self = this;

        self.model3dEditMode = status;

        self.propertyParams = angular.copy(self.property);
        self.propertyErrors = {};
    }

    updatePropertyModel3d(remove) {
        const self = this;

        if (remove) {
            self.propertyParams.model_3d = null;
        } else {
            self.propertyParams.model_3d = self.propertyParams.model_3d.trim();
        }

        // Is Changed
        if (self.propertyParams.model_3d == self.property.model_3d) {
            self.editPropertyModel3d(false);
            return;
        }

        self.OTPService.getVerified(
            self.OTPService.TYPE_SESSION_2FA,
            function (data) {

                let url = 'sec/developer/properties/'+self.property.id+'/update';
                let params = self.propertyParams;
                self.propertyErrors = {};

                loading(true);
                self.SSHttpService.postAPIRequest(url, params).then(function (response) {
                    loading(false);

                    if (response instanceof Error) {
                        self.SSAlertService.parseAndDisplayError(response);
                        self.propertyErrors = self.SSHttpService.parseErrors(response);
                        return;
                    }

                    self.SSAlertService.success('Success!', 'Project 3D Model updated successfully.');

                    self.property = response.data.property;

                    self.editPropertyNamedId(false);
                });
            }
        );
    }
    // 3D Model URL ----------------------------------------------------------------------------------------------------
}

PropertyAssetsController.$inject = ['SSHttpService', 'SSUtilService', 'SSAlertService', 'OTPService', 'SSConfigService', 'SSAwsService', 'SSUserService'];
app.controller('PropertyAssetsController', PropertyAssetsController);

